import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=8da10baa&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8da10baa')) {
      api.createRecord('8da10baa', component.options)
    } else {
      api.reload('8da10baa', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=8da10baa&", function () {
      api.rerender('8da10baa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Z1QdSMuQWfG7/JS/comp/openstreetmap.vue"
export default component.exports